import '@fontsource/ubuntu/400.css'
import '@fontsource/ubuntu/500.css'
import '@fontsource/ubuntu/700.css'
import './src/sass/style.scss'
import './src/templates/Pricing/PricingPage.scss'
import 'Shared/sass/style.scss'

import {
  MauticOnRouteChange,
  MauticOnWebLoad,
} from 'Shared/mautic/EasyProject/EPMauticScripts'
import { initDynamicRS } from 'Shared/utils/dynamicRS'
import { removeAllParamsWhenUTM } from 'Shared/utils/removeUTM'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onClientEntry = () => {
  console.log(`Init DynamicRS`)

  if (document.querySelector(`.pux-notfound`)) {
    removeAllParamsWhenUTM(window.location.href)
  }
  initDynamicRS()
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onInitialClientRender = () => {
  console.log(`Load Mautic`)
  MauticOnWebLoad()
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onRouteUpdate = () => {
  MauticOnRouteChange()
}
